import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const HistoryIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M6.04 11.96C6.04 15.26 8.68 17.98 12 17.98C15.3 17.98 17.96 15.26 17.96 11.96C17.96 8.64 15.3 5.84 12 5.84C9.98 5.84 8.1 6.8 6.84 8.88H10V10.3H4.16V4.28H5.66V7.74C7.16 5.42 9.38 4.1 12 4.1C16.3 4.1 19.84 7.68 19.84 11.96C19.84 16.24 16.3 19.78 12 19.78C7.7 19.78 4.16 16.24 4.16 11.96H6.04ZM14.92 13.46H11.12V9.02H12.68V11.9H14.92V13.46Z" />
    </SvgIcon>
  );
});
